// src/columns/publications.js

/**
 * Fabrique un tableau de colonnes pour Tabulator avec injection de callbacks
 * @param {Function} deleteHandler - Fonction à appeler sur clic "🗑️ Delete"
 * @returns {Array} - Colonnes Tabulator
 */
const getPublicationColumns = (deleteHandler) => [
    {
      title: "Publication Name",
      field: "publicationName",
      widthGrow: 2,
      headerFilter: "input",
      formatter: function(cell) {
        try {
          const value = cell.getValue();
          const rowData = cell.getRow().getData();

          // Vérifier si c'est une publication CAT
          const isCAT = rowData.progressionType === 'adaptive' ||
                       (rowData.testId?.progression === 'adaptive');

          // Ajouter un badge CAT si applicable
          if (isCAT) {
            return `<span><strong>${value}</strong> <span class="badge bg-info ms-2" title="CAT Test">🐈 CAT</span></span>`;
          }

          return value;
        } catch (error) {
          return cell.getValue() || '';
        }
      }
    },
    { title: "Status", field: "status", widthGrow: 1, headerFilter: "input" },
    { title: "Group", field: "groupId.groupName", widthGrow: 1, headerFilter: "input" },
    { title: "Test", field: "testId.title", widthGrow: 1, headerFilter: "input" },
    { 
      title: "Type", 
      field: "progressionType", 
      width: 80,
      hozAlign: "center",
      headerFilter: "input",
      formatter: function(cell) {
        try {
          let value = cell.getValue();
          const rowData = cell.getRow().getData();
          
          // 🛡️ Vérification de sécurité pour éviter les erreurs sur tests supprimés
          if (!rowData) {
            return '<span title="Données manquantes">❓</span>';
          }
          
          // Fallback: si progressionType n'existe pas, vérifier testId.progression
          if (!value || value === 'linear') {
            // 🛡️ Vérification complète de l'existence du test
            if (rowData.testId && typeof rowData.testId === 'object' && rowData.testId.progression) {
              value = rowData.testId.progression;
            } else if (rowData.testId && typeof rowData.testId === 'string') {
              // Si testId est juste un string (test supprimé), utiliser linear par défaut
              value = 'linear';
            } else if (!rowData.testId) {
              return '<span title="Test manquant">❌</span>';
            }
          }
          
          // Normaliser la valeur (en cas de valeurs legacy)
          if (value === 'Linear') value = 'linear';
          if (value === 'Adaptive') value = 'adaptive';
          
          // Retourner l'icône appropriée
          switch (value) {
            case "adaptive":
              return '<span title="Adaptive CAT Test">🐈</span>';
            case "conditional":
              return '<span title="Conditional Test">🔀</span>';
            case "chosen":
              return '<span title="Chosen Path Test">🎯</span>';
            case "stages":
              return '<span title="Stages Test">🎭</span>';
            default:
              return '<span title="Linear Test">🚆</span>';
          }
        } catch (error) {
          return '<span title="Erreur de formatage">⚠️</span>';
        }
      }
    },
    { title: "Mode", field: "mode", widthGrow: 1, headerFilter: "input" },
    { title: "startingDate", field: "startingDate", headerFilter: "input" },
    { title: "endDate", field: "endDate", headerFilter: "input" },
    {
      title: "Reports",
      field: "reports",
      headerSort: false,
      widthGrow: 1,
      formatter: (cell) => {
        try {
          const reports = cell.getValue();
          if (!reports || typeof reports !== 'object') return "";
          
          return `
            ${reports.studentReport ? '<i class="icon-download" title="Student Report">Stud</i>' : ""}
            ${reports.groupReport ? '<i class="icon-download" title="Group Report">Group</i>' : ""}
            ${reports.statisticReport ? '<i class="icon-download" title="Statistic Report">Stat</i>' : ""}
          `;
        } catch (error) {
          return '<span title="Erreur">⚠️</span>';
        }
      },
    },
    {
      title: "Actions",
      headerSort: false,
      width: 100,
      hozAlign: "center",
      formatter: (cell) => {
        try {
          const rowData = cell.getRow().getData();
          if (!rowData || !rowData._id) {
            console.warn('⚠️ Données de ligne invalides pour le bouton Delete');
            return '<span title="Données invalides">⚠️</span>';
          }

          const button = document.createElement("button");
          button.innerHTML = '<i class="bi bi-trash3"></i>';
          button.classList.add("delete-btn");
          button.setAttribute("title", "Delete publication");
          button.addEventListener("click", (e) => {
            e.stopPropagation();
            console.log('🔥 Delete button clicked for ID:', rowData._id);
            console.log('🔥 deleteHandler type:', typeof deleteHandler);
            if (typeof deleteHandler === 'function') {
              console.log('🔥 Calling deleteHandler...');
              deleteHandler(rowData._id);
            } else {
              console.error('❌ deleteHandler n\'est pas une fonction', deleteHandler);
            }
          });
          return button;
        } catch (error) {
          console.error('❌ Erreur dans le formatter Actions:', error);
          return '<span title="Erreur">⚠️</span>';
        }
      },
    }
  ];
  
  // 👇 C'est ce qu’il manquait !
  export default getPublicationColumns;
  